import * as Sentry from '@sentry/react';
import to from 'await-to-js';
import { saveAs } from 'file-saver';
import JsZip from 'jszip';
import moment from 'moment';

import { getMediaClient } from '@/client/media';
import { notify } from '@/components/toast';
/**
 * @function multipleFileDownload
 * @param {array} data // [{digest, key}]
 * @param {String} customFileName
 */

export const multipleFileDownload = async (
  data: Record<string, any>[],
  customFileName?: string
) => {
  const fileName: string =
    customFileName ?? `trace-${moment().format('YYYY-MM-DD-HH-mm-ss')}.zip`;

  // download all the files as blobs
  const downloadBlobsPromises = Promise.all(
    data.map(async ({ digest, key }) =>
      to(getMediaClient().downloadFile(digest, undefined, key))
    )
  );

  notify.promise(downloadBlobsPromises, {
    loading: 'Creating zip file',
    success: 'Your files were downloaded as zip',
    error: 'Failed to create and download zip file.'
  });

  const blobs = await downloadBlobsPromises;

  let hasErr = false;

  blobs?.forEach(val => {
    if (!val || val[0]) {
      hasErr = true;
    }
  });

  if (hasErr) {
    notify.error('Error while downloading all the files');
    Sentry.captureException(new Error('Error while downloading all the files'));
    return;
  }
  const zipFile = JsZip();

  blobs.forEach(element => {
    const file = element[1];
    zipFile.file(file.name, file);
  });

  const zipBlob = await zipFile.generateAsync({ type: 'blob' });

  saveAs(zipBlob, fileName);
};
